import script from "./ImprintComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImprintComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ImprintComponent.vue?vue&type=style&index=0&id=523db118&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523db118"]])

export default __exports__